import { render } from "./mnewsList.vue?vue&type=template&id=584e960a&scoped=true"
import script from "./mnewsList.vue?vue&type=script&lang=js"
export * from "./mnewsList.vue?vue&type=script&lang=js"

import "./mnewsList.vue?vue&type=style&index=0&id=584e960a&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584e960a"]])

export default __exports__